function getShortcutParams({
  query_gameformat,
  hasDepthList = false,
  hasStacksList = false,
  hasAverageStack = false,
  tableRows,
}) {
  let depth = null
  let stacks = null
  let depth_list = null
  let average_stack = null
  let stacks_list = null
  let game_modes = null
  let gametypes = null

  if (hasDepthList) {
    depth_list = query_gameformat.depth_list?.split(',').filter(i => i)
  } else if (hasAverageStack) {
    average_stack = query_gameformat.average_stack?.split(',').filter(i => i)
  } else if (hasStacksList) {
    stacks_list = query_gameformat.stacks_list?.split(',').filter(i => i)

    // if to many stacks, use depth_list instead of game_modes ids
    if (stacks_list.length > 300) {
      // to many stacks, use depth_list instead of game_modes ids
      let depths = tableRows.map(i => (i.selected ? i.depth : null)).filter(i => i)
      depths = [...new Set(depths)]
      depth_list = depths.map(i => Number(i))
    } else {
      const gmfIds = tableRows.map(i => (i.selected ? i.gameformats[0].id : null)).filter(i => i)
      game_modes = gmfIds.join()
    }
  } else {
    stacks = query_gameformat.stacks
    depth = query_gameformat.depth
  }

  const allAny = !depth_list?.length && !average_stack?.length && !stacks_list?.length

  if (
    (hasDepthList && !depth_list?.length) ||
    (hasAverageStack && !average_stack?.length) ||
    (hasStacksList && !stacks_list?.length)
  ) {
    const list = tableRows.map(i => i?.row_id)

    if (hasDepthList) {
      depth_list = list.map(i => Number(i))
      depth_list = [...new Set(depth_list)]
    } else if (hasAverageStack) {
      average_stack = list.map(i => Number(i))
    } else if (hasStacksList) {
      // if to many stacks, use depth_list instead of game_modes ids
      if (tableRows.length > 300) {
        // to many stacks, use depth_list instead of game_modes ids
        let depths = tableRows.map(i => i.depth)
        depths = [...new Set(depths)]
        depth_list = depths.map(i => Number(i))
      } else {
        const gmfIds = tableRows.map(i => i.gameformats[0].id)
        game_modes = gmfIds.join()
      }
    }
  }

  const includeGametypes = hasDepthList || hasAverageStack || hasStacksList
  if (includeGametypes) {
    const selectedRows = allAny ? tableRows : tableRows.filter(i => i.selected)

    gametypes = selectedRows.reduce(
      (a, b) => [
        ...a,
        ...(b.gameformats ? b.gameformats.map(i => i.gametype) : [b.gametype]), // cash table rows are just gameformats
      ],
      [],
    )
    gametypes = [...new Set(gametypes)]
    // console.log(gametypes)
  }

  const { gametype } = query_gameformat
  const res = {
    ...(!gametypes ? { gametype } : {}),
    ...(gametypes ? { gametypes } : {}),

    ...(depth ? { depth } : {}),
    ...(stacks ? { stacks } : {}),

    ...(depth_list ? { depth_list } : {}),
    ...(average_stack ? { average_stack } : {}),
    ...(game_modes ? { game_modes } : {}),
  }

  // console.log({
  //   query_gameformat,
  //   hasDepthList,
  //   hasStacksList,
  //   hasAverageStack,
  //   rootGetters,
  //   namespace,
  //   res,
  // })
  // debugger
  return res
}
const shortcuts = {
  api_poker_shortcuts(
    { dispatch, rootGetters },
    { namespace, gameformat, action } = { namespace: '', hasDepthList: false },
  ) {
    const query_gameformat =
      gameformat || rootGetters[`${namespace ? `${namespace}/` : ''}query_gameformat`]
    const gmf_params = getShortcutParams({
      query_gameformat,
    })

    const callId = `poker/shortcuts/${new URLSearchParams(gmf_params)}`
    dispatch('api_call', {
      endpoint: 'poker/shortcuts/',
      mutation: 'api_poker_shortcuts',
      mutationArgs: { namespace },
      ...(action ? { action } : {}),
      gwCacheId: callId,
      gwCacheAdd: true,
      waitForCache: true,
      params: gmf_params,
    })
  },
  api_poker_available_shortcuts(
    { dispatch, rootGetters },
    {
      namespace,
      // gameformat,
      query_gameformat,
      tableRows,
      hasDepthList = false,
      hasStacksList = false,
      hasAverageStack = false,
    } = { namespace: '', hasDepthList: false },
  ) {
    // debugger
    // const query_gameformat =
    // gameformat || rootGetters[`${namespace ? `${namespace}/` : ''}query_gameformat`]
    // debugger
    const gmf_params = getShortcutParams({
      query_gameformat,
      hasDepthList,
      hasStacksList,
      hasAverageStack,
      tableRows,
      // namespace,
    })

    const callId = `poker/shortcuts/available-shortcuts/${new URLSearchParams(gmf_params)}`
    // console.log(callId)
    dispatch('api_call', {
      endpoint: 'poker/shortcuts/available-shortcuts/',
      mutation: 'api_poker_available_shortcuts',
      mutationArgs: { namespace },
      gwCacheId: callId,
      gwCacheAdd: true,
      waitForCache: true,
      params: gmf_params,
    })
  },
  api_poker_shortcuts_flop({ dispatch }) {
    const params = {
      report: 'flop',
    }
    dispatch('api_call', {
      endpoint: 'poker/shortcuts/',
      mutation: 'api_poker_shortcuts_flop',
      params,
    })
  },
  api_poker_shortcuts_card({ dispatch }) {
    const params = {
      report: 'card',
    }
    dispatch('api_call', {
      endpoint: 'poker/shortcuts/',
      mutation: 'api_poker_shortcuts_card',
      params,
    })
  },
}

export default shortcuts
